import { gasApi } from '@/api/gas'
import { DEFAULT_MONITOR_DEVICE_TYPE, isCustomDataType, normalizeDeviceType, formatMetricColumnLabel, metricValueFromRow } from '@/config/deviceTypeMetrics'
import { protocolParamsToMetrics, protocolsForDeviceType } from '@/config/protocolParamNames'

export { DEFAULT_MONITOR_DEVICE_TYPE }

export default {
  data() {
    return {
      customProtocolOptions: [],
      customProtocolMetrics: []
    }
  },
  computed: {
    isCustomReportType() {
      return isCustomDataType(this.query && this.query.deviceType)
    },
    showCustomProtocolFilter() {
      return true
    },
    isPressureReportType() {
      return normalizeDeviceType(this.query && this.query.deviceType) === '压力远传'
    },
    useTypedMetricColumns() {
      return true
    },
    reportMetricColumns() {
      return this.customProtocolMetrics
    },
    showReportSubDevice() {
      return !this.isCustomReportType && !this.isPressureReportType
    },
    reportMergeDevice() {
      return this.showReportSubDevice
    },
    canLoadCustomReport() {
      return !!(this.query && (this.query.protocolId || this.query.protocolName))
    }
  },
  created() {
    if (this.loadCustomProtocolOptions) this.loadCustomProtocolOptions()
  },
  methods: {
    formatMetricColumnLabel,
    reportMetricValue(row, metric) {
      return metricValueFromRow(row, metric)
    },
    defaultReportTypeQuery() {
      return {
        deviceType: DEFAULT_MONITOR_DEVICE_TYPE,
        protocolId: null,
        protocolName: ''
      }
    },
    onReportDeviceTypeChange() {
      this.query.pageNum = 1
      this.query.protocolId = null
      this.query.protocolName = ''
      this.customProtocolMetrics = []
      this.list = []
      this.total = 0
      this.loadCustomProtocolOptions()
      if (this.loadStats) this.loadStats()
    },
    async onReportProtocolChange(protocolId) {
      const hit = (this.customProtocolOptions || []).find(p => p.protocolId === protocolId)
      this.query.protocolId = protocolId || null
      this.query.protocolName = hit ? (hit.protocolName || '') : ''
      this.query.pageNum = 1
      await this.loadCustomProtocolColumns()
      if (!this.query.protocolId) {
        this.list = []
        this.total = 0
        if (this.loadStats) this.loadStats()
        return
      }
      this.search()
    },
    async loadCustomProtocolOptions() {
      const deviceType = this.query && this.query.deviceType
      try {
        const res = await gasApi.protocol.list({ pageNum: 1, pageSize: 500 })
        this.customProtocolOptions = protocolsForDeviceType((res.data && res.data.records) || [], deviceType)
      } catch (e) {
        this.customProtocolOptions = []
      }
    },
    async loadCustomProtocolColumns() {
      if (!this.query.protocolId) {
        this.customProtocolMetrics = []
        return
      }
      try {
        const res = await gasApi.protocol.paramList({
          protocolId: this.query.protocolId,
          pageNum: 1,
          pageSize: 200
        })
        const records = (res.data && res.data.records) || []
        const protocol = (this.customProtocolOptions || []).find(p => p.protocolId === this.query.protocolId)
        this.customProtocolMetrics = protocolParamsToMetrics(records, this.query.deviceType, protocol)
      } catch (e) {
        this.customProtocolMetrics = []
      }
    }
  }
}
